import React from 'react';
import { ImageStylesProps, StyledCloudImage } from './PositionedStaticImages.styles';

export interface PositionStaticImageProps {
  url: string;
  belowSm: ImageStylesProps;
  sm: ImageStylesProps;
}

export interface Props {
  readonly isMainSrcShown: boolean;
  readonly images: PositionStaticImagesProps;
}

export type PositionStaticImagesProps = PositionStaticImageProps[];

export const PositionedStaticImages: React.FC<Props> = ({ isMainSrcShown, images }) => {
  return (
    <>
      {images.map((image, index) => (
        <StyledCloudImage
          isMainSrcShown={isMainSrcShown}
          key={`StyledCloudImage-${index}`}
          src={image.url}
          mobile={image.belowSm}
          sm={image.sm}
        />
      ))}
    </>
  );
};
